import Icon from "@/components/Icon.vue";
import LPDatePicker from "@/components/LPDatePicker/lp-date-picker.vue";
import "@/styles/index.scss";
import "@/utils/test";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/display.css";
import "element-ui/lib/theme-chalk/index.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import "./utils/permission";

Vue.component('Icon', Icon);
Vue.component('lp-date-picker', LPDatePicker);

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

Vue.use(Element);
Vue.prototype.refresh = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
